/* Publish by EComposer at 2024-06-07 16:05:38*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rud0jp9txt"]=  window.__ectimmers["ecom-rud0jp9txt"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-rud0jp9txt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rud0jp9txt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2nucgza85i6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2nucgza85i6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h16x09viyri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h16x09viyri', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2w4nlcl5psg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2w4nlcl5psg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahvloqj89k8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahvloqj89k8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kq5hvwvhzdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kq5hvwvhzdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tvynr4wcfr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvynr4wcfr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5qh96s0gtq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5qh96s0gtq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6hyc4jpxprk"]=  window.__ectimmers["ecom-6hyc4jpxprk"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-6hyc4jpxprk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6hyc4jpxprk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3axnn67dosc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3axnn67dosc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ko4p7eofpy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ko4p7eofpy', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1jwlgl2ro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1jwlgl2ro', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}